import React from 'react';
import { GridProps, Grid } from '@mui/material';
import { defaultGridItemProps } from 'util/layout';

export const GridItem: React.FunctionComponent<GridProps> = ({ children, ...props }) => (
  <Grid {...defaultGridItemProps} {...props}>
    {children}
  </Grid>
);

export default GridItem;
